import styles from "./styles.module.scss";
import o_image from "../../images/o.png";
import Section from "../../components/Section";

const Hero = () => {
  return (
    <Section>
      <div className={styles.container}>
        <p className={styles.date}>Ноябрь 2024</p>
        <div className={styles.title}>
          <div className={styles.img}>
            <div>
              П{" "}
              <span>
                <img src={o_image} alt="" />
              </span>{" "}
              РТФ
              <span>
                <img src={o_image} alt="" />
              </span>
              ЛИ
              <span>
                <img src={o_image} alt="" />
              </span>
            </div>
          </div>
          <p className={styles.name}>Веб-дизайнер | UX / UI</p>
        </div>
        <p className={styles.description}>
          Это портфолио демонстрирует мои навыки с базовыми задачами в дизайне
          (адаптивность, навигация, подбор цветов и т.д.)
          <br />
          <br />
          Если вы хотите ознакомиться с дизайном конкретных веб-сайтов, то
          приглашаю вас на мой Behance/GitHub
        </p>
      </div>
    </Section>
  );
};

export default Hero;
